import { SESSION_EXPIRED, CLEAR_SESSION_EXPIRED } from './types';

export const sessionExpired = (payload) => ({
  type: SESSION_EXPIRED,
  payload,
});

export const clearSessionExpired = () => ({
  type: CLEAR_SESSION_EXPIRED,
});
